module.exports = __webpack_public_path__ + "media/images/your-idea-img-fa2722e79a3c508a3dd0b9cfd2a73849.jpg";